import { Union } from "./.fable/fable-library.3.2.9/Types.js";
import { int32_type, union_type, string_type } from "./.fable/fable-library.3.2.9/Reflection.js";
import { empty, cons, head, tail, isEmpty } from "./.fable/fable-library.3.2.9/List.js";
import { printf, toText } from "./.fable/fable-library.3.2.9/String.js";

export class Token extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["L_BRACK", "R_BRACK", "IDENT", "COMMA", "OR", "AND", "NOT", "IMP", "BIMP"];
    }
}

export function Token$reflection() {
    return union_type("Lexer.Token", [], Token, () => [[], [], [["Item", string_type]], [], [], [], [], [], []]);
}

export function format_token(token) {
    switch (token.tag) {
        case 1: {
            return ")";
        }
        case 2: {
            const v = token.fields[0];
            return v;
        }
        case 3: {
            return ",";
        }
        case 4: {
            return "∪";
        }
        case 5: {
            return "∩";
        }
        case 6: {
            return "¬";
        }
        case 7: {
            return "→";
        }
        case 8: {
            return "↔";
        }
        default: {
            return "(";
        }
    }
}

export class TokenAssoc extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["LEFT", "RIGHT", "NA"];
    }
}

export function TokenAssoc$reflection() {
    return union_type("Lexer.TokenAssoc", [], TokenAssoc, () => [[], [], []]);
}

export class TokenArity extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["UNARY", "BINARY", "NA"];
    }
}

export function TokenArity$reflection() {
    return union_type("Lexer.TokenArity", [], TokenArity, () => [[], [], []]);
}

export class TokenData extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["TokenData"];
    }
}

export function TokenData$reflection() {
    return union_type("Lexer.TokenData", [], TokenData, () => [[["Item1", TokenAssoc$reflection()], ["Item2", int32_type], ["Item3", TokenArity$reflection()]]]);
}

export function token_data(token_type) {
    switch (token_type.tag) {
        case 1: {
            return new TokenData(0, new TokenAssoc(2), -1, new TokenArity(2));
        }
        case 2: {
            return new TokenData(0, new TokenAssoc(2), -1, new TokenArity(2));
        }
        case 3: {
            return new TokenData(0, new TokenAssoc(1), 1, new TokenArity(1));
        }
        case 4: {
            return new TokenData(0, new TokenAssoc(0), 4, new TokenArity(1));
        }
        case 5: {
            return new TokenData(0, new TokenAssoc(0), 5, new TokenArity(1));
        }
        case 6: {
            return new TokenData(0, new TokenAssoc(1), 6, new TokenArity(0));
        }
        case 7: {
            return new TokenData(0, new TokenAssoc(0), 3, new TokenArity(1));
        }
        case 8: {
            return new TokenData(0, new TokenAssoc(0), 2, new TokenArity(1));
        }
        default: {
            return new TokenData(0, new TokenAssoc(2), -1, new TokenArity(2));
        }
    }
}

export function token_assoc(token_type) {
    const assoc = token_data(token_type).fields[0];
    return assoc;
}

export function token_prec(token_type) {
    const prec = token_data(token_type).fields[1] | 0;
    return prec | 0;
}

export function token_arity(token_type) {
    const arity = token_data(token_type).fields[2];
    return arity;
}

export function tokenize(char_stream_mut) {
    let c;
    tokenize:
    while (true) {
        const char_stream = char_stream_mut;
        if (!isEmpty(char_stream)) {
            const t = tail(char_stream);
            const h = head(char_stream);
            if (h === "\t") {
                char_stream_mut = t;
                continue tokenize;
            }
            else if (h === "\n") {
                char_stream_mut = t;
                continue tokenize;
            }
            else if (h === "\r") {
                char_stream_mut = t;
                continue tokenize;
            }
            else if (h === " ") {
                char_stream_mut = t;
                continue tokenize;
            }
            else if (h === "(") {
                return cons(new Token(0), tokenize(t));
            }
            else if (h === ")") {
                return cons(new Token(1), tokenize(t));
            }
            else if ((c = h, (c <= "z") ? (c >= "a") : false)) {
                const c_1 = h;
                return cons(new Token(2, c_1), tokenize(t));
            }
            else {
                switch (h) {
                    case "\u0026": {
                        return cons(new Token(5), tokenize(t));
                    }
                    case ",": {
                        return cons(new Token(3), tokenize(t));
                    }
                    case "-": {
                        if (!isEmpty(t)) {
                            const t_1 = tail(t);
                            const h_1 = head(t);
                            if (h_1 === "\u003e") {
                                return cons(new Token(7), tokenize(t_1));
                            }
                            else {
                                throw (new Error(toText(printf("unexpected character %c"))(h_1)));
                            }
                        }
                        else {
                            throw (new Error(toText(printf("unexpected character %c"))(h)));
                        }
                    }
                    case "\u003c": {
                        if (!isEmpty(t)) {
                            const t_2 = tail(t);
                            const h_2 = head(t);
                            if (h_2 === "-") {
                                if (!isEmpty(t_2)) {
                                    const t_3 = tail(t_2);
                                    const h_3 = head(t_2);
                                    if (h_3 === "\u003e") {
                                        return cons(new Token(8), tokenize(t_3));
                                    }
                                    else {
                                        throw (new Error(toText(printf("unexpected character %c"))(h_3)));
                                    }
                                }
                                else {
                                    throw (new Error(toText(printf("unexpected character %c"))(h_2)));
                                }
                            }
                            else {
                                throw (new Error(toText(printf("unexpected character %c"))(h_2)));
                            }
                        }
                        else {
                            throw (new Error(toText(printf("unexpected character %c"))(h)));
                        }
                    }
                    case "|": {
                        return cons(new Token(4), tokenize(t));
                    }
                    case "~": {
                        return cons(new Token(6), tokenize(t));
                    }
                    default: {
                        throw (new Error(toText(printf("unexpected character %c"))(h)));
                    }
                }
            }
        }
        else {
            return empty();
        }
        break;
    }
}

